import * as React from "react";
import LiquorImg from "../liquor-img";
import ListButton from "./list-button";
import ProductDetails from "../product-details";
import MadeInAlberta from "../made-in-alberta";
import CONSTS from "../../consts";
export default class ProductItem extends React.Component {
    constructor(props) {
        super(props);
        this.imageError = (imageNum) => {
            let newImageSet = [...this.state.unavailableImages];
            newImageSet.push(imageNum);
            this.setState({
                unavailableImages: newImageSet
            });
        };
        this.setImage = (newUrl) => {
            this.setState({
                currentImageSrc: newUrl,
                imageSelected: true,
            });
        };
        this.state = {
            unavailableImages: [],
            currentImageSrc: ``,
            imageSelected: false
        };
    }
    componentWillReceiveProps(nextProps, props) {
        if (!this.state.imageSelected) {
            this.setState({
                currentImageSrc: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${nextProps.product.SKU}.jpg`
            });
        }
    }
    renderImage(source, index, className) {
        return React.createElement("img", { className: className, src: source, onClick: () => this.setImage(source), onError: () => this.imageError(index), alt: "liquor-img" });
    }
    render() {
        let product = this.props.product;
        const agentImages = ["-Agent1", "-Agent2", "-BrandLogo"];
        const imageExtensions = [".jpg", ".png", ".gif"];
        const images = [];
        if (this.props.product.SKU) {
            let index = 0;
            for (var ext of imageExtensions) {
                if (this.state.unavailableImages.indexOf(index) == -1) {
                    const productSource = `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}${ext}`;
                    images.push(this.renderImage(productSource, index, this.state.currentImageSrc == product ? 'active' : ""));
                    index++;
                }
            }
            for (var aImage of agentImages) {
                for (var extension of imageExtensions) {
                    if (this.state.unavailableImages.indexOf(index) == -1) {
                        let imageSource = `${CONSTS.STORAGEURL}/${CONSTS.AGENTCONTAINER}/${product.SKU}${aImage}${extension}`;
                        images.push(this.renderImage(imageSource, index, this.state.currentImageSrc == imageSource ? 'active' : ""));
                    }
                    index++;
                }
            }
        }
        //TODO verify sub-header and Varietal
        return (React.createElement("div", { className: "product-desc" },
            React.createElement("div", { className: "showcased-img" },
                React.createElement(LiquorImg, { src: this.state.currentImageSrc })),
            React.createElement("div", { className: "product-list" },
                React.createElement(MadeInAlberta, { madeInAlberta: product.MadeInAlberta }),
                React.createElement("h5", { className: "sub-header" }, product.AgentName),
                React.createElement("h1", { className: "header" }, product.Name),
                React.createElement("p", { className: "id" },
                    "SKU: ",
                    product.DisplaySKU),
                React.createElement("div", { className: "img-selection" }, images),
                React.createElement("div", { className: "mobile-img" },
                    React.createElement(LiquorImg, { src: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg` })),
                React.createElement("div", { className: "button-list" },
                    React.createElement("a", { href: `/Products/Stores/${product.SKU}` },
                        React.createElement("button", { className: "btn-primary btn-primary__filled" }, "Where To Buy")),
                    React.createElement(ListButton, { id: product.SKU })),
                React.createElement("p", { className: "disclaimer" }, "Please contact the store to confirm availability. A retailer may sell out of any product at any time."),
                React.createElement(ProductDetails, { product: this.props.product }))));
    }
}
;
//# sourceMappingURL=product-desc.js.map